var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnassignedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unassigned-icon-g-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unassigned-icon-g-2",
    transform: "translate(-1352.000000, -276.000000)",
    fill: "#515D75",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1366,284 C1368.21,284 1370,282.21 1370,280 C1370,277.79 1368.21,276 1366,276 C1363.79,276 1362,277.79 1362,280 C1362,282.21 1363.79,284 1366,284 Z M1357,282 L1357,279 L1355,279 L1355,282 L1352,282 L1352,284 L1355,284 L1355,287 L1357,287 L1357,284 L1360,284 L1360,282 L1357,282 Z M1366,286 C1363.33,286 1358,287.34 1358,290 L1358,292 L1374,292 L1374,290 C1374,287.34 1368.67,286 1366,286 Z",
    id: "unassigned-icon-shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignedIcon);
export default __webpack_public_path__ + "static/media/unassigned-icon.e0e4a11a.svg";
export { ForwardRef as ReactComponent };